import React from 'react';
import { useSpring, animated } from '@react-spring/web';

const LoadingModal = ({ isVisible }) => {
  const springProps = useSpring({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0%)' : 'translateY(100%)',
    config: { tension: 300, friction: 20 },
  });

  return (
    <animated.div style={{
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: springProps.transform.to(t => `${t} translateX(-50%)`),
      opacity: springProps.opacity,
      padding: '20px',
      background: 'white',
      color: 'black',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      borderRadius: '5px',
      zIndex: 1000,
      pointerEvents: isVisible ? 'auto' : 'none',
    }}>
      Preparing your file...
    </animated.div>
  );
};

export default LoadingModal;